import cx from 'classnames';
import { memo } from 'react';
import { NavLink } from 'react-router-dom';

import styles from './NavMenuLinks.module.scss';

import useNavItems from './useNavLinks';

const NavMenuLinks = () => {
  const { isBlured, items, onRouteClick } = useNavItems();

  return (
    <aside className={styles.navMenu}>
      <nav className={cx(styles.nav, styles.blurable, { [styles.isBlured]: isBlured })}>
        {items.map((item) => (
          <NavLink
            key={item.key}
            to={item.to}
            end={item.end}
            replace={item.replace}
            onClick={onRouteClick}
            data-staff-name={item.dataStaffName}
            className={({ isActive }) => item.className(isActive)}
          >
            {item.content}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default memo(NavMenuLinks);
